import { useQuery } from '@tanstack/react-query';
import {
  searchTraceLogs,
  getTraceById,
} from '../services/feeTracingService';
import {
  TraceContextLogViewModel,
  TraceContextLogSummaryViewModel,
  SearchTraceLogRequest,
} from '../models/feeTracing';
import { ProcessedTraceLog, GroupedTraceLogs } from '../models/tracing';
import { processTraceLogs, groupTraceLogs } from '../utils/traceLogUtils';

// ===== Main Hook =====

export const useFeeTracing = (transactionId?: string) => {
  const traceLogsQuery = useQuery<TraceContextLogViewModel[]>({
    queryKey: ['trace-logs', transactionId],
    queryFn: () => getTraceById(transactionId!),
    enabled: !!transactionId && transactionId.length > 0,
    staleTime: 60_000, // 1 minute - trace logs are immutable
    refetchOnWindowFocus: false,
  });

  const processedLogs = traceLogsQuery.data ? processTraceLogs(traceLogsQuery.data) : [];
  const groupedLogs = traceLogsQuery.data ? groupTraceLogs(processedLogs) : [];

  return {
    traceLogsQuery,
    processedLogs,
    groupedLogs,
  };
};

export const useFeeTracingSearch = (params: SearchTraceLogRequest, enabled: boolean = false, type: string = 'Fees') => {
  const searchQuery = useQuery<TraceContextLogSummaryViewModel[]>({
    queryKey: ['trace-logs-search', type, params],
    queryFn: () => searchTraceLogs(type, params),
    enabled,
    staleTime: 10_000, // 10 seconds - trace logs are historical
    refetchOnWindowFocus: false,
  });

  return {
    searchQuery,
  };
};

